import { changeDate, headerDateFormatLastLogin } from "helpers/date";
import { getAppleDeviceName } from "helpers/appleDeviceModels";

export const FIRST_REPORTING_VERSION = "1.7.0";

export const formatMobileVersion = (row) => {
	if (row?.lastMobileAppVersion) {
		const seen = row.lastMobileSeen
			? ` · ${changeDate(row.lastMobileSeen)}`
			: "";
		return `${row.lastMobileAppVersion} (${row.lastMobileAppBuild})${seen}`;
	}
	return row?.hasMobileLogin ? `Older than ${FIRST_REPORTING_VERSION}` : "—";
};

export const getLastMobileConnectionLabel = (row) => {
	if (row?.lastMobileAppVersion) {
		const seen = row.lastMobileSeen
			? ` · ${headerDateFormatLastLogin(row.lastMobileSeen)}`
			: "";
		return `${row.lastMobileAppVersion} (${row.lastMobileAppBuild})${seen}`;
	}
	if (row?.hasMobileLogin) {
		return `Older than ${FIRST_REPORTING_VERSION}`;
	}
	return null;
};

export const getDeviceLabel = (row) => {
	const deviceName = getAppleDeviceName(row?.lastMobileDeviceModel);
	const osVersion = row?.lastMobileOSVersion;
	if (deviceName && osVersion) {
		return `${deviceName} · ${osVersion}`;
	}
	return deviceName || osVersion || null;
};
